import styled from "styled-components";
import './style.css'
import { FaUserCircle } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from 'react-i18next';


const DivBGtransparent = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showConfirmInfo }) => (showConfirmInfo ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  align-items: center;
  justify-content: center;
  opacity: ${({ showConfirmInfo }) => (showConfirmInfo ? '1' : '0')};
  transition: opacity 0.25s ease;
  animation: ${({ showConfirmInfo }) => (showConfirmInfo ? 'modalFadeIn 0.25s ease forwards' : 'none')};

  @keyframes modalFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const DivContainer = styled.div`
    z-index: 10000;
    position: relative;
    width: 90%;
    max-width: 480px;
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease;

    @keyframes modalSlideUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
`;

const ModalConfirmInfoCliente = ({showConfirmInfo, 
    setShowConfirmInfo,
    namePersonData,
    whatsappData,
    id_empresa,
    setClientCompleteData,
    setItensCarrinho,
    itensCarrinho,
    selectedItemId,
    showPedido, setRefresh, 
    //tipoImpressao
}) => {
    const { t } = useTranslation('cardapio');

    const editInfo = () => {
        setShowConfirmInfo(!showConfirmInfo);        
    }

    // Apenas salva os dados localmente - o cliente será registrado junto com o pedido
    const handleSaveOnServer = () => {
        // Salvar dados do cliente no localStorage para uso posterior
        const clienteData = {
            nome: namePersonData,
            telefone: whatsappData,
            endereco: []
        };

        // Atualizar localPersonInfo no localStorage
        const localPersonInfo = JSON.parse(localStorage.getItem('localPersonInfo') || '{}');
        localPersonInfo.nome = namePersonData;
        localPersonInfo.telefone = whatsappData;
        localStorage.setItem('localPersonInfo', JSON.stringify(localPersonInfo));

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Dados do cliente salvos localmente:', clienteData);

        // Passar dados para o componente pai
        setClientCompleteData(clienteData);
        setShowConfirmInfo(!showConfirmInfo);
    }

    return (
        <DivBGtransparent showConfirmInfo={showConfirmInfo}>
            <DivContainer>

                {/*<div className="divTitleItemAdicionado">
                    <span className="divTitleItemAdicionadoSpan">Item teste</span> 
                    <span className="divTitleItemAdicionadoSpan">adicionado ao carrinho!</span>
                </div>*/}

                <div style={{textAlign:'center',marginBottom: '10px'}}>
                    <span className="titleConfirmInfo">{t('modal.confirmInfo.title')}</span>
                </div>

                <div className="nomeInfoContainer">
                    <span className="quantityText">{t('modal.confirmInfo.yourName')}</span>                                
                    <div className="divPaiInputsInfoCliente">
                        <FaUserCircle style={{fontSize:'30px',color:'gray'}}/>
                        <span className="spanModalInfoCliente">{namePersonData}</span> 
                    </div>                     
                </div>

                <div className="nomeInfoContainer">
                    <span className="quantityText">{t('modal.confirmInfo.yourWhatsapp')}</span>                                
                    <div className="divPaiInputsInfoCliente">
                        <FaWhatsapp style={{fontSize:'30px',color:'gray'}}/>
                        <span className="spanModalInfoCliente">{whatsappData}</span> 
                    </div>                     
                </div>

                <div className="divBtnContinueCart">
                    <button className="buttonContinue" onClick={()=> editInfo()}>{t('modal.confirmInfo.editInfo')}</button>
                    <div style={{width:'100%'}}>
                        <button onClick={()=> handleSaveOnServer()} className="buttonCart">{t('modal.confirmInfo.confirm')}</button>
                    </div>
                </div>

            </DivContainer>
        </DivBGtransparent>
    );
}

export default ModalConfirmInfoCliente